import React, { useEffect, useState } from 'react';
import { change, Field } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { Words, CounterWords } from './styled';
import { FieldForm } from '@app/src/common/FieldForm';
import { ExampleModal } from '@app/src/views/StepOne/form/components';
import { renderTextarea } from './renderTextarea';
import * as validate from '@app/src/utils/validations';
import { normalizeDescription } from '@app/src/utils/normalize';
import { Alert } from '@app/src/common/Alert';
import { fetchFreeExtracharge } from '@app/src/views/StepOne/form';
import { CATEGORIES, CATEGORY } from '@app/src/config/categories';

interface Props {
  includeWords: number;
  extraWords?: number;
}

const MAX_CHAR_WORD = 12;

export const Description: React.FC<Props> = ({
  includeWords,
  extraWords
}) => {
  const dispatch = useDispatch();
  const { title, description } = useSelector(state => state.form.stepOne.values);
  const print = useSelector(state => state.print.general);
  const categoryId = print && print.category;
  const categoryConfig = CATEGORIES[CATEGORY[categoryId]];
  const isLoadingFreeWordPrice = useSelector(state => state.freeExtracharge.isFetching);
  const isErrorFreeWordPrice = useSelector(state => state.freeExtracharge.error);
  const [countExtraWord, setCountExtraWord] = useState(0);
  const freeWordData = useSelector(state => state.freeExtracharge.data);
  const freeWordPrice = freeWordData && freeWordData[0] && freeWordData[0].price;
  const typeUserAction = useSelector(state => state.session.user.pasarella);

  useEffect(() => {
    if (print && print.description) {
      dispatch(change('stepOne', 'description', print.description));
    }
    if (typeUserAction === 'purchase-print') {
      dispatch(fetchFreeExtracharge(print && print.category));
    }
  }, []);

  useEffect(() => {
    if (title && print.title !== title) {
      dispatch(change('stepOne', 'description', ''));
    }
  }, [title]);

  useEffect(() => {
    let wordCount = 0;
    if (totalCounter(description) > includeWords) {
      wordCount = totalCounter(description) - includeWords;
      dispatch(change('stepOne', 'extraWords', wordCount));
    } else {
      dispatch(change('stepOne', 'extraWords', null));
    }
    setCountExtraWord(wordCount);
  }, [description]);

  const totalCounter = (value: string): number => {
    if (value) {
      let words = value.split(' ');
      let countWords = words.length;
      if (countWords && words[countWords - 1] === '') {
        return countWords;
      }
      return countWords + 1;
    }
    return title ? 1 : 0;
  }

  const getMaxWords = (): number => extraWords ? includeWords + extraWords - 1 : includeWords - 1;

  const formatPrice = (price: number) => price && price.toFixed(2);

  return (
    <FieldForm
      label='Descripción del aviso'
      subtext="No olvides ingresar tus datos de contacto"
      componentRight={extraWords ? <ExampleModal configTheme={categoryConfig} price={formatPrice(freeWordPrice)} /> : null}>
      <Field
        name="description"
        title={title}
        placeholder="Ingrese descripción del aviso y datos de contacto &#10;Ejm: xxxxx xxxxx xxxxx xxx &#10;$9999.000 C.999999999"
        component={renderTextarea}
        normalize={normalizeDescription(MAX_CHAR_WORD, getMaxWords())}
        validate={[validate.required]}
        value={description}
      />
      <Words>
        <span>Tienes {includeWords} palabras incluidas.</span>
        <span>N° Palabras: <CounterWords>{totalCounter(description)}</CounterWords></span>
      </Words>
      {extraWords ?
        <Alert color="#f0f0f0">
          {
            (isLoadingFreeWordPrice || isErrorFreeWordPrice) ?
              'Cargando...'
              :
              <React.Fragment>
                Adicional palabras extra <strong>({countExtraWord})</strong> S/{formatPrice(freeWordPrice)} c/u. No incluye IGV.
              </React.Fragment>
          }
        </Alert> : null
      }
    </FieldForm>
  )
}
